import { createSelector } from '@ngrx/store';
import { featureSelect, FeatureState } from '../settings';

export const getRecords = createSelector(
    featureSelect,
    (state: FeatureState) => state.brands
);

export const getDeleteError = createSelector(
    featureSelect,
    (state: FeatureState) => state.brandsDeleteError
);
